<template>
    <div>
        <div v-show="!mostrarRateios">
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblComprometimentos"
                :itens="comprometimentos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <btn-comprometer-selecionados
                        v-if="
                            $temAcessoView('CONT-COMPR-01') &&
                            controleHistoricoAditivos()
                        "
                        class="float-right"
                        :contrato="contrato"
                        :comprometimentosSelecionados="
                            comprometimentosSelecionados
                        "
                        @atualizarComprometimentos="obterComprometimentos()"
                        @atualizarErros="erros = $event"
                    ></btn-comprometer-selecionados>
                    <btn-atualizar-historicos
                        class="float-right mr-2"
                        v-if="
                            $temAcessoView('CONT-COMPR-04') &&
                            controleHistoricoAditivos()
                        "
                        :contrato="contrato"
                        :comprometimentosSelecionados="
                            comprometimentosSelecionados
                        "
                        @atualizarComprometimentos="obterComprometimentos()"
                        @atualizarErros="erros = $event"
                    ></btn-atualizar-historicos>
                </template>
                <template slot="idRm" slot-scope="data">
                    {{ data.idRm }}
                    <status-id-mov :comprometimento="data"></status-id-mov>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-movimento
                        :comprometimento="data"
                        :erros="erros"
                        v-if="
                            $temAcessoView('CONT-COMPR-01') &&
                            data.status == 1 &&
                            controleHistoricoAditivos()
                        "
                        @atualizarComprometimento="obterComprometimentos()"
                    ></btn-atualizar-movimento>
                    <btn-mostrar-rateios
                        titulo="Comprometer"
                        icone="fa-check-circle-o"
                        :comprometimento="data"
                        @atualizarComprometimento="comprometimento = $event"
                        v-if="
                            $temAcessoView('CONT-COMPR-01') &&
                            data.status == 1 &&
                            controleHistoricoAditivos()
                        "
                    ></btn-mostrar-rateios>
                    <btn-mostrar-rateios
                        @atualizarComprometimento="comprometimento = $event"
                        :comprometimento="data"
                        v-if="data.status != 1"
                    ></btn-mostrar-rateios>
                    <btn-descomprometer
                        :contrato="contrato"
                        :comprometimento="data"
                        :tipo="1"
                        @atualizarComprometimento="obterComprometimentos()"
                        @atualizarErros="erros = $event"
                        v-if="
                            data.status == 4 &&
                            $temAcessoView('CONT-COMPR-03') &&
                            controleHistoricoAditivos()
                        "
                    >
                    </btn-descomprometer>
                    <btn-bloquear-desbloquear
                        :contrato="contrato"
                        :comprometimento="data"
                        @atualizarComprometimentos="
                            obterComprometimentos($event)
                        "
                        v-if="
                            (data.status == 1 || data.status == 7) &&
                            $temAcessoView('CONT-COMPR-05') &&
                            controleHistoricoAditivos()
                        "
                    >
                    </btn-bloquear-desbloquear>
                </template>
                <template slot="nuValorComprometimento" slot-scope="data">
                    {{ data.nuValorComprometimento | currency }}
                </template>
                <template slot="HEAD_comprometimentoSelecao">
                    <i
                        class="
                            fa fa-check-square fa-lg
                            text-muted
                            icon-button
                            p-0
                            m-0
                        "
                        title="Marcar/Desmarcar todos"
                        @click.stop="marcarDesmarcarTodas()"
                    ></i>
                </template>
                <template slot="comprometimentoSelecao" slot-scope="data">
                    <b-form-checkbox
                        :value="data.idComprometimentoRequisicao"
                        v-model="comprometimentosSelecionados"
                        v-if="data.status === 1"
                    ></b-form-checkbox>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarRateios">
            <rateios
                :contrato="contrato"
                :comprometimento="comprometimento"
                @atualizarComprometimento="atualizarComprometimento($event)"
            >
            </rateios>
        </div>
    </div>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'
import Rateios from './rateios/Rateios'
import BtnMostrarRateios from './BtnMostrarRateios'
import BtnComprometerSelecionados from './BtnComprometerSelecionados'
import BtnDescomprometer from './BtnDescomprometer'
import BtnAtualizarHistoricos from './BtnAtualizarHistoricos'
import BtnBloquearDesbloquear from './BtnBloquearDesbloquear'
import { situacaoContrato } from '../SituacaoContrato'
import StatusIdMov from './StatusIdMov'
import BtnAtualizarMovimento from '../../comum/comprometimentos/BtnAtualizarMovimento.vue'

export default {
    components: {
        Rateios,
        BtnMostrarRateios,
        BtnComprometerSelecionados,
        BtnDescomprometer,
        BtnAtualizarHistoricos,
        BtnBloquearDesbloquear,
        StatusIdMov,
        BtnAtualizarMovimento
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            comprometimentos: [],
            comprometimento: null,
            comprometimentosSelecionados: [],
            erros: [],
            campos: [
                {
                    key: 'comprometimentoSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'chaveOrigem',
                    label: 'Id',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcHistorico',
                    label: 'Histórico',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtEmissao',
                    label: 'Data Emissão',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'date'
                },
                {
                    key: 'dtMovimento',
                    label: 'Data Vencimento',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'date'
                },
                {
                    key: 'nuValorComprometimento',
                    label: 'Valor',
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'vcTipoMovimento',
                    label: 'Tipo do Movimento',
                    tdClass: 'text-nowrap text-right'

                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'status'
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {
        marcarDesmarcarTodas() {
            if (this.comprometimentosSelecionados.length > 0) {
                this.comprometimentosSelecionados = []
            } else {
                this.comprometimentosSelecionados = this.comprometimentos
                    .filter((item) => {
                        return item.status === 1
                    })
                    .map((item) => {
                        return item.idComprometimentoRequisicao
                    })
            }
        },

        atualizarComprometimento(comprometimento) {
            if (
                JSON.stringify(this.comprometimento) !=
                JSON.stringify(comprometimento)
            ) {
                this.obterComprometimentos()
            }
            this.comprometimento = comprometimento
        },

        obterComprometimentos(comprometimentos) {
            this.comprometimentosSelecionados = []
            if (comprometimentos) {
                this.comprometimentos = comprometimentos
            } else {
                this.obterComprometimentosBase()
            }
        },

        obterComprometimentosBase() {
            this.$store.dispatch('addRequest')
            ComprometimentosServicos.obterComprometimentosParcelasFixasEntregas(
                this.contrato.idContrato
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.comprometimentos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            'Erro ao obter os comprometimentos do contrato'
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {
        this.comprometimentos = this.contrato.comprometimentos
    },

    computed: {
        mostrarRateios() {
            return this.comprometimento !== null
        }
    },

    watch: {
        contrato() {
            this.comprometimentos = this.contrato.comprometimentos
        }
    }
}
</script>
